import React from "react";

const QuickViewButton = ({ onClick }) => {
  return (
    <div onClick={onClick} className="quick_btn_outside">
      <button className="quick_btn buttonBlueBorder">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
        >
          <path
            d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
            fill="white"
            stroke="#404040"
          />
        </svg>
      </button>
    </div>
  );
};

export default QuickViewButton;
